import styles from "./StockPricesTable.module.css"
import Arrow from "@components/general/icons/arrow/Arrow"
import { isToday } from "@utils/time"
import { QuotesResponse } from "@ts/interfaces/quotesResponse.interface"
import TrendArrow from "@components/general/icons/trendArrow/TrendArrow"
import React from "react"
import Container from "@components/layout/container/Container"
import { Table, TableBody, TableCell, TableRow } from "@components/dataDisplay/table/Table"

const StockPricesTable = ({ quotesResponse }: { quotesResponse: QuotesResponse }) => {
  const quotes = quotesResponse.payload ?? []
  return (
    <Container title="Die Börse im Überblick">
      <Table className={styles.customTable}>
        <TableBody>
          {quotes.map((quote, i) => (
            <TableRow key={i}>
              <TableCell className={styles.tableGrp}>
                <div className={styles.name}>{quote.name}</div>
                <div className={styles.date}>
                  {isToday(new Date(quote.currentPriceDate))
                    ? quote.currentPriceDateFormattedSecs.split(" ")[0].split(":").slice(0, 2).join(":")
                    : quote.currentPriceDateSoloFormatted}
                </div>
              </TableCell>
              <TableCell className={styles.price}>{quote.currentPriceFormatted}</TableCell>
              <TableCell
                className={`${styles.priceArrow} ${
                  quote.dailyChangeRelFormatted[0] === "+" ? styles.positive : styles.negative
                }`}
              >
                <TrendArrow positive={quote.dailyChangeRelFormatted[0] === "+"} />
              </TableCell>
              <TableCell
                className={`${styles.dailyChange} ${
                  quote.dailyChangeRelFormatted[0] === "+" ? styles.positive : styles.negative
                }`}
              >
                {quote.dailyChangeRelFormatted}
              </TableCell>
              <TableCell className={styles.arrow}>
                {quote.fuwUrl && (
                  // TODO: remove `/boerse` prefix once migrated to the new boerse frontend (paths are root-relative there)
                  <a href={`https://wp.fuw.ch/boerse${quote.fuwUrl}`} target="_parent">
                    <Arrow rotation={270} />
                  </a>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  )
}

export default StockPricesTable
